import React from "react";

// Style
import { Svg } from "./styles";

const Rhomboid = ({ size = 60 }) => {
  // <path d="M 0 0 L 0 0 H 300 V 100 H 30" />;
  const width = (size*2)+(size/16);
  const radius = (size/2);
  
  return (
    <Svg width={width} height={size}> 
        <rect width={width-size} height={size} x={radius} />

        {/* Second circle to darken the first */}
        <circle cx={radius} cy={radius} r={radius} />
        <circle cx={radius} cy={radius} r={radius} fill="rgba(0, 0, 0, .2)" />

        {/* Second circle to darken the first */}
        <circle cx={width-radius} cy={radius} r={radius} />
        <circle cx={width-radius} cy={radius} r={radius} fill="rgba(0, 0, 0, .2)" />
    </Svg>
  );
};

export default Rhomboid;
